var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileMov = function SvgFileMov(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M7.8.6h8.67c1.103 0 2.162.434 2.948 1.208l7.729 7.609A4.2 4.2 0 0 1 28.4 12.41V27.2a4.2 4.2 0 0 1-4.2 4.2H7.8a4.2 4.2 0 0 1-4.2-4.2V4.8A4.2 4.2 0 0 1 7.8.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M18 1v6.8a3.2 3.2 0 0 0 3.2 3.2H28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC4899",
    d: "M0 17a3 3 0 0 1 3-3h21a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.277 24H6.29L4.77 19.371V24H3.546v-6.318H5.35l1.46 4.496 1.452-4.496h1.77V24H8.798v-4.629zm3.716-3.16c0-1.909 1.25-3.255 2.992-3.255 1.734 0 2.983 1.346 2.983 3.256s-1.25 3.256-2.983 3.256c-1.742 0-2.992-1.347-2.992-3.256m4.673 0c0-1.293-.695-2.12-1.68-2.12-.995 0-1.69.827-1.69 2.12s.695 2.122 1.69 2.122c.985 0 1.68-.828 1.68-2.121m5.09 3.16h-1.355l-2.332-6.318h1.39l1.637 4.664 1.646-4.664h1.329z"
  })));
};
export default SvgFileMov;